import React, { SetStateAction } from 'react';
import { CellContext } from '@tanstack/react-table';

import Actions from '@components/common/Actions';
import AdaptiveTableCell from '@components/common/AdaptiveTableCell';

import { dateFormattingWithSlash } from '@utils/date';
import { getDateWithoutOffset } from '@utils/kpi-utils/date';

import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';

interface IProps {
	setCurrentVesDataId: React.Dispatch<SetStateAction<string | undefined>>;
	setIsNetconfPreviewModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const getNetconfColumns = ({ setCurrentVesDataId, setIsNetconfPreviewModalOpen }: IProps) => [
	{
		header: 'Network Element',
		accessorKey: 'networkElementName',
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: 'Middleware',
		accessorKey: 'middlewareName',
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: 'Event type',
		accessorKey: 'eventType',
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: 'Event time',
		accessorKey: 'eventTime',
		cell: ({ getValue }: CellContext<IMiddlewareSMO, any>) => {
			const value = getValue();
			const dateWithoutOffset = getDateWithoutOffset(value);
			const date = dateFormattingWithSlash(dateWithoutOffset);

			return value && <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'Actions',
		accessorKey: 'actions',
		enableSorting: false,
		cell: ({ row }: CellContext<any, any>) => {
			const { original } = row;
			const { id } = original;

			const handleOpenEvent = () => {
				setCurrentVesDataId(id);
				setIsNetconfPreviewModalOpen(true);
			};

			return (
				<Actions
					isOpenModal
					openModalHandler={handleOpenEvent}
				/>
			);
		},
	},
];
